import PropTypes from "prop-types"
import React from "react"

import ToggleGroup from "src/components/ToggleGroup"

const ITEMS = [
  { value: "table", label: "Table", icon: "fa-solid fa-list" },
  { value: "cards", label: "Cards", icon: "fa-solid fa-table-cells-large" },
]

const ViewSwitcher = ({ view, onChange }) => (
  <div className="print:hidden">
    <ToggleGroup
      variant="icon"
      ariaLabel="Choose list layout"
      items={ITEMS}
      value={view}
      onChange={onChange}
    />
  </div>
)

ViewSwitcher.propTypes = {
  view: PropTypes.oneOf(["table", "cards"]).isRequired,
  onChange: PropTypes.func.isRequired,
}

export default ViewSwitcher
